import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileVersicherungSection = () => <IndustryBenefitsI18n translationPrefix="industryVersicherung" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileVersicherungSection;
